import { Input, ButtonV2 } from '@getgrover/ui';
import React, { useEffect } from 'react';
import styled, { css } from 'styled-components';
import { useForm, Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { useMutation } from '@apollo/client';
import { sendAnalyticsEvent } from '@devsbb/analytics-client';
import PeaceHand from 'assets/PeaceHand.svg';
import 'assets/Nessie.svg';
import Squid from 'assets/Squid.svg';

const Container$2 = styled.figure`
  height: 24px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  &::after,
  &::before {
    content: '';
    height: 4px;
    flex: 1 1 auto;
    background-color: ${(props)=>props.theme.colors['Level 1']};
    border-radius: 2px;
    margin: 0 ${({ theme  })=>theme.spacers.M};
  }
`;
const Text$2 = styled.figcaption`
  color: ${(props)=>props.theme.colors['Level 5']};
  ${(props)=>css(props.theme.typography.SmallCapsHeadline)}

  text-align: center;
  white-space: nowrap;

  max-width: 80%;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Delimiter = ({ children  })=>/*#__PURE__*/ React.createElement(Container$2, null, /*#__PURE__*/ React.createElement(Text$2, null, children));

const getPasswordErrorKey = (formErrors)=>{
    if (formErrors.password) {
        if (formErrors.password.type === 'required') return 'SIGN_UP_PASSWORD_REQUIRED';
        if (formErrors.password.type === 'minLength') return 'SIGN_UP_PASSWORD_INVALID';
    }
    return '';
};
const getEmailErrorKey = (formErrors)=>{
    if (formErrors.email) {
        if (formErrors.email.type === 'required') return 'SIGN_UP_EMAIL_REQUIRED';
    }
    return '';
};

var HeaderKey;
(function(HeaderKey) {
    HeaderKey["CONTENT_TYPE"] = 'Content-Type';
    HeaderKey["LOCALE_REQUEST"] = 'x-grover-language';
    HeaderKey["STORE_REQUEST"] = 'x-grover-store';
    HeaderKey["USER_AGENT_REQUEST"] = 'x-user-agent';
    HeaderKey["USER_REQUEST"] = 'x-grover-user';
    HeaderKey["DEVICE_REQUEST"] = 'x-grover-device-id';
    HeaderKey["SESSION_REQUEST"] = 'x-grover-session-id';
    HeaderKey["ORDER_REQUEST"] = 'x-grover-order-token';
    HeaderKey["AUTHORIZATION"] = 'Authorization';
})(HeaderKey || (HeaderKey = {}));
var CookieKey;
(function(CookieKey) {
    CookieKey["ACCESS_TOKEN"] = 'api_access_token';
    CookieKey["REFRESH_TOKEN"] = 'api_refresh_token';
    CookieKey["USER_ID"] = 'user_id';
    CookieKey["SHOP_COUNTRY_CODE"] = 'shop_country_code';
    CookieKey["LOCALE"] = 'locale';
    CookieKey["DEVICE_ID"] = 'deviceId';
    CookieKey["SESSION_ID"] = 'ggId';
    CookieKey["STORE"] = 'x-grover-store';
})(CookieKey || (CookieKey = {}));

/*! js-cookie v3.0.1 | MIT */ /* eslint-disable no-var */ function assign(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source){
            target[key] = source[key];
        }
    }
    return target;
}
/* eslint-enable no-var */ /* eslint-disable no-var */ var defaultConverter = {
    read: function(value) {
        if (value[0] === '"') {
            value = value.slice(1, -1);
        }
        return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
    },
    write: function(value) {
        return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
    }
};
/* eslint-enable no-var */ /* eslint-disable no-var */ function init(converter, defaultAttributes) {
    function set(key, value, attributes) {
        if (typeof document === 'undefined') {
            return;
        }
        attributes = assign({}, defaultAttributes, attributes);
        if (typeof attributes.expires === 'number') {
            attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
        }
        if (attributes.expires) {
            attributes.expires = attributes.expires.toUTCString();
        }
        key = encodeURIComponent(key).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
        var stringifiedAttributes = '';
        for(var attributeName in attributes){
            if (!attributes[attributeName]) {
                continue;
            }
            stringifiedAttributes += '; ' + attributeName;
            if (attributes[attributeName] === true) {
                continue;
            }
            // Considers RFC 6265 section 5.2:
            // ...
            // 3.  If the remaining unparsed-attributes contains a %x3B (";")
            //     character:
            // Consume the characters of the unparsed-attributes up to,
            // not including, the first %x3B (";") character.
            // ...
            stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
        }
        return document.cookie = key + '=' + converter.write(value, key) + stringifiedAttributes;
    }
    function get(key) {
        if (typeof document === 'undefined' || arguments.length && !key) {
            return;
        }
        // To prevent the for loop in the first place assign an empty array
        // in case there are no cookies at all.
        var cookies = document.cookie ? document.cookie.split('; ') : [];
        var jar = {};
        for(var i = 0; i < cookies.length; i++){
            var parts = cookies[i].split('=');
            var value = parts.slice(1).join('=');
            try {
                var foundKey = decodeURIComponent(parts[0]);
                jar[foundKey] = converter.read(value, foundKey);
                if (key === foundKey) {
                    break;
                }
            } catch (e) {}
        }
        return key ? jar[key] : jar;
    }
    return Object.create({
        set: set,
        get: get,
        remove: function(key, attributes) {
            set(key, '', assign({}, attributes, {
                expires: -1
            }));
        },
        withAttributes: function(attributes) {
            return init(this.converter, assign({}, this.attributes, attributes));
        },
        withConverter: function(converter) {
            return init(assign({}, this.converter, converter), this.attributes);
        }
    }, {
        attributes: {
            value: Object.freeze(defaultAttributes)
        },
        converter: {
            value: Object.freeze(converter)
        }
    });
}
var api = init(defaultConverter, {
    path: '/'
});

const getLocale = ()=>api.get(CookieKey.LOCALE) || 'de';
const getStore = ()=>api.get(CookieKey.STORE) || 'de';

const getGroverUrl = ()=>window && `${window.location.origin}/${getStore()}-${getLocale()}`;

var AuthRoutesPath;
(function(AuthRoutesPath) {
    AuthRoutesPath["PASSWORD_RECOVERY"] = '/auth?flow=PASSWORD_RECOVERY';
    AuthRoutesPath["SIGN_UP"] = '/auth?flow=SIGN_UP_CUSTOMER_WITH_WELCOME_QUIZ';
})(AuthRoutesPath || (AuthRoutesPath = {}));

const Form = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;
const StyledInput = styled(Input)`
  width: 100%;
  margin-bottom: ${(props)=>props.theme.spacers.XL};
  margin-top: ${(props)=>props.theme.spacers.XL};
`;
const RecoveryLink = styled.a`
  align-self: baseline;
  color: ${({ theme  })=>theme.colors['Level 4']};
  ${(props)=>css(props.theme.typography.TinyParagraph)};
  margin-bottom: ${(props)=>props.theme.spacers.XL};
  font-style: italic;
  cursor: pointer;
  text-decoration: underline;
  :hover,
  :active {
    color: ${({ theme  })=>theme.colors['Level 4']};
  }
`;
const ButtonsContainer = styled.div`
  width: 100%;
  heigth: 100%;
  margin-top: ${(props)=>props.theme.spacers.XXL};
`;

const LoginForm = ({ onSubmit , showSignupButton =true , showRecoveryLink =true  })=>{
    const { handleSubmit , control , errors  } = useForm();
    const { t  } = useTranslation('translator');
    return /*#__PURE__*/ React.createElement(Form, {
        onSubmit: handleSubmit(onSubmit),
        "data-testid": "LoginForm"
    }, /*#__PURE__*/ React.createElement(Controller, {
        rules: {
            required: true
        },
        as: /*#__PURE__*/ React.createElement(StyledInput, {
            label: t('SIGN_IN_EMAIL'),
            error: t(getEmailErrorKey(errors))
        }),
        name: "email",
        control: control
    }), /*#__PURE__*/ React.createElement(Controller, {
        rules: {
            required: true,
            minLength: 6
        },
        as: /*#__PURE__*/ React.createElement(StyledInput, {
            label: t('SIGN_IN_PASSWORD'),
            passwordWithIcon: true,
            error: t(getPasswordErrorKey(errors))
        }),
        name: "password",
        control: control
    }), showRecoveryLink && /*#__PURE__*/ React.createElement(RecoveryLink, {
        href: `${getGroverUrl()}${AuthRoutesPath.PASSWORD_RECOVERY}`
    }, t('SIGN_IN_FORGOT_PASSWORD')), /*#__PURE__*/ React.createElement(ButtonsContainer, null, /*#__PURE__*/ React.createElement(ButtonV2, {
        type: "submit",
        fullWidth: true
    }, t('SIGN_IN')), showSignupButton && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Delimiter, null, t('SIGN_IN_NEW_HERE')), /*#__PURE__*/ React.createElement(ButtonV2, {
        fullWidth: true,
        outlined: true,
        href: `${getGroverUrl()}${AuthRoutesPath.SIGN_UP}`
    }, t('GO_TO_SIGN_UP')))));
};

const useQueryParams = ()=>{
    const { search  } = useLocation();
    return React.useMemo(()=>new URLSearchParams(search), [
        search
    ]);
};

var doc$1 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "groverLogin"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "info"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "GroverLoginInfo"
                            }
                        }
                    },
                    "directives": []
                }
            ],
            "directives": [],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "groverLogin"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "info"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "info"
                                    }
                                }
                            }
                        ],
                        "directives": [],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "authToken"
                                    },
                                    "arguments": [],
                                    "directives": []
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ],
    "loc": {
        "start": 0,
        "end": 97
    }
};
doc$1.loc.source = {
    "body": "mutation groverLogin($info: GroverLoginInfo!) {\n  groverLogin(info: $info) {\n    authToken\n  }\n}\n",
    "name": "GraphQL request",
    "locationOffset": {
        "line": 1,
        "column": 1
    }
};
// Collect any fragment/type references from a node, adding them to the refs Set
function collectFragmentReferences$1(node, refs) {
    if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
    } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
            refs.add(type.name.value);
        }
    }
    if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
            collectFragmentReferences$1(selection, refs);
        });
    }
    if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
            collectFragmentReferences$1(def, refs);
        });
    }
    if (node.definitions) {
        node.definitions.forEach(function(def) {
            collectFragmentReferences$1(def, refs);
        });
    }
}
var definitionRefs$1 = {};
(function extractReferences() {
    doc$1.definitions.forEach(function(def) {
        if (def.name) {
            var refs = new Set();
            collectFragmentReferences$1(def, refs);
            definitionRefs$1[def.name.value] = refs;
        }
    });
})();
function findOperation$1(doc, name) {
    for(var i = 0; i < doc.definitions.length; i++){
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
            return element;
        }
    }
}
function oneQuery$1(doc, operationName) {
    // Copy the DocumentNode, but clear out the definitions
    var newDoc = {
        kind: doc.kind,
        definitions: [
            findOperation$1(doc, operationName)
        ]
    };
    if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
    }
    // Now, for the operation we're running, find any fragments referenced by
    // it or the fragments it references
    var opRefs = definitionRefs$1[operationName] || new Set();
    var allRefs = new Set();
    var newRefs = new Set();
    // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
    opRefs.forEach(function(refName) {
        newRefs.add(refName);
    });
    while(newRefs.size > 0){
        var prevRefs = newRefs;
        newRefs = new Set();
        prevRefs.forEach(function(refName) {
            if (!allRefs.has(refName)) {
                allRefs.add(refName);
                var childRefs = definitionRefs$1[refName] || new Set();
                childRefs.forEach(function(childRef) {
                    newRefs.add(childRef);
                });
            }
        });
    }
    allRefs.forEach(function(refName) {
        var op = findOperation$1(doc, refName);
        if (op) {
            newDoc.definitions.push(op);
        }
    });
    return newDoc;
}
const groverLogin = oneQuery$1(doc$1, "groverLogin");

var doc = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "updatePSD2Challenge"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "info"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "PSD2ChallengeInfo"
                            }
                        }
                    },
                    "directives": []
                }
            ],
            "directives": [],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "psd2Challenge"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "info"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "info"
                                    }
                                }
                            }
                        ],
                        "directives": [],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "personId"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "redirectUrl"
                                    },
                                    "arguments": [],
                                    "directives": []
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ],
    "loc": {
        "start": 0,
        "end": 124
    }
};
doc.loc.source = {
    "body": "mutation updatePSD2Challenge($info: PSD2ChallengeInfo!) {\n  psd2Challenge(info: $info) {\n    personId\n    redirectUrl\n  }\n}\n",
    "name": "GraphQL request",
    "locationOffset": {
        "line": 1,
        "column": 1
    }
};
// Collect any fragment/type references from a node, adding them to the refs Set
function collectFragmentReferences(node, refs) {
    if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
    } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
            refs.add(type.name.value);
        }
    }
    if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
            collectFragmentReferences(selection, refs);
        });
    }
    if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
            collectFragmentReferences(def, refs);
        });
    }
    if (node.definitions) {
        node.definitions.forEach(function(def) {
            collectFragmentReferences(def, refs);
        });
    }
}
var definitionRefs = {};
(function extractReferences() {
    doc.definitions.forEach(function(def) {
        if (def.name) {
            var refs = new Set();
            collectFragmentReferences(def, refs);
            definitionRefs[def.name.value] = refs;
        }
    });
})();
function findOperation(doc, name) {
    for(var i = 0; i < doc.definitions.length; i++){
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
            return element;
        }
    }
}
function oneQuery(doc, operationName) {
    // Copy the DocumentNode, but clear out the definitions
    var newDoc = {
        kind: doc.kind,
        definitions: [
            findOperation(doc, operationName)
        ]
    };
    if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
    }
    // Now, for the operation we're running, find any fragments referenced by
    // it or the fragments it references
    var opRefs = definitionRefs[operationName] || new Set();
    var allRefs = new Set();
    var newRefs = new Set();
    // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
    opRefs.forEach(function(refName) {
        newRefs.add(refName);
    });
    while(newRefs.size > 0){
        var prevRefs = newRefs;
        newRefs = new Set();
        prevRefs.forEach(function(refName) {
            if (!allRefs.has(refName)) {
                allRefs.add(refName);
                var childRefs = definitionRefs[refName] || new Set();
                childRefs.forEach(function(childRef) {
                    newRefs.add(childRef);
                });
            }
        });
    }
    allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
            newDoc.definitions.push(op);
        }
    });
    return newDoc;
}
const updatePSD2Challenge = oneQuery(doc, "updatePSD2Challenge");

const Text$1 = styled.span`
  ${(props)=>css(props.theme.typography.TinyParagraph)};
  font-weight: 600;
  letter-spacing: 0.02em;
  color: #f44336;
  > span > a {
    color: #f44336;
    text-decoration: underline;
    cursor: pointer;
  }
`;

const ErrorMessage = ({ children  })=>/*#__PURE__*/ React.createElement(Text$1, null, children);

const Container$1 = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: ${({ theme  })=>theme.spacers.M};
`;
const Image$1 = styled.img`
  width: 30%;
  height: auto;
  margin: 0 auto;

  @media ${({ theme  })=>theme.screens.mobileMax} {
    width: 90%;
  }

  @media ${({ theme  })=>theme.screens.tabletMax} {
    width: 40%;
  }
`;
const ErrorText = styled.p`
  ${({ theme  })=>theme.typography.SmallCapsHeadline};
  margin-top: ${({ theme  })=>theme.spacers.L};
  color: ${({ theme  })=>theme.colors.Foreground};
`;
const Title$1 = styled.h2`
  ${({ theme  })=>theme.typography.Subheadline};
  margin-top: ${({ theme  })=>theme.spacers.L};
  color: ${({ theme  })=>theme.colors.Foreground};
  text-align: center;
`;
const Text = styled.p`
  ${({ theme  })=>theme.typography.Paragraph};
  margin-top: ${({ theme  })=>theme.spacers.L};
  color: ${({ theme  })=>theme.colors.Foreground};
  text-align: center;
  width: 50%;
  @media ${({ theme  })=>theme.screens.mobileMax} {
    width: 90%;
  }
`;
const ExternalLink = styled(ButtonV2)`
  margin-top: ${({ theme  })=>theme.spacers.L};
`;

const Page500 = ({ className , errorStatus =500 , hasButton =false  })=>{
    const { t  } = useTranslation('translator');
    return /*#__PURE__*/ React.createElement(Container$1, {
        className: className
    }, /*#__PURE__*/ React.createElement(Image$1, {
        src: Squid
    }), /*#__PURE__*/ React.createElement(ErrorText, null, t('ERROR_PAGE_500_SMALLCAPS_HEADLINE', {
        errorStatus
    })), /*#__PURE__*/ React.createElement(Title$1, null, t('ERROR_PAGE_500_TITLE')), /*#__PURE__*/ React.createElement(Text, null, t('ERROR_PAGE_500_TEXT')), hasButton ? /*#__PURE__*/ React.createElement(ExternalLink, {
        href: "/"
    }, t('ERROR_PAGE_500_BUTTON_TEXT')) : null);
};

var Events;
(function(Events) {
    Events["loginStarted"] = 'Login Started';
    Events["loginSuccess"] = 'Login Success';
    Events["redirectOpenBanking"] = 'Redirect Third Party';
})(Events || (Events = {}));

var Views;
(function(Views) {
    Views["openBanking"] = 'OpenBanking View';
    Views["page500"] = 'Internal Error View';
})(Views || (Views = {}));

const Title = styled.h1`
  color: ${(props)=>props.theme.colors.Foreground};
  margin-bottom: ${(props)=>props.theme.spacers.XL};
  ${(props)=>css(props.theme.typography.Subheadline)};
`;
const Container = styled.div`
  max-width: 720px;
  margin: auto;
  margin-top: ${(props)=>props.theme.spacers.XXL};
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: ${(props)=>props.theme.spacers.XL};
`;
const Image = styled.img`
  width: 30%;
  max-width: 72px;
  border-radius: 50%;
  height: auto;
  margin: ${(props)=>props.theme.spacers.XXL} 0;
  background-color: ${(props)=>props.theme.colors['Level 1']};
`;

const OpenBanking = ()=>{
    const queryParams = useQueryParams();
    const challengeId = queryParams.get('psd2_challenge_id');
    const { t  } = useTranslation('translator');
    useEffect(()=>{
        sendAnalyticsEvent(Views.openBanking);
    }, [
        challengeId
    ]);
    const [updatePSD2, { error: updatePSD2Error  }] = useMutation(updatePSD2Challenge, {
        fetchPolicy: 'network-only',
        variables: {
            info: {
                challengeId: challengeId || ''
            }
        },
        onCompleted: (data)=>{
            sendAnalyticsEvent(Events.redirectOpenBanking, {
                URL: data.psd2Challenge.redirectUrl
            });
            window.location.replace(data.psd2Challenge.redirectUrl);
        }
    });
    const [login, { error: loginError  }] = useMutation(groverLogin, {
        fetchPolicy: 'network-only',
        onCompleted: (data)=>{
            sendAnalyticsEvent(Events.loginSuccess);
            updatePSD2({
                context: {
                    headers: {
                        [HeaderKey.AUTHORIZATION]: `Bearer ${data.groverLogin.authToken}`
                    }
                }
            });
        }
    });
    const handleLogin = (data)=>{
        sendAnalyticsEvent(Events.loginStarted);
        login({
            variables: {
                info: data
            }
        });
    };
    if (updatePSD2Error) {
        return /*#__PURE__*/ React.createElement(Page500, null);
    }
    return /*#__PURE__*/ React.createElement(Container, {
        "data-testid": "OpenBanking"
    }, /*#__PURE__*/ React.createElement(Image, {
        src: PeaceHand
    }), /*#__PURE__*/ React.createElement(Title, null, t('SIGN_IN_OPEN_BANKING')), loginError ? /*#__PURE__*/ React.createElement(ErrorMessage, null, t('SIGN_IN_OPEN_BANKING_FAILED_LOGIN')) : null, /*#__PURE__*/ React.createElement(LoginForm, {
        onSubmit: (e)=>{
            handleLogin(e);
        },
        showSignupButton: false,
        showRecoveryLink: false
    }));
};

export { LoginForm, OpenBanking, useQueryParams };
